import { external as externalScript } from '../../utils/script'
import { isBrowsiEnabled } from '../config/browsiScriptConfig'
function loadBrowsiScript() {
  externalScript.load({
    name: 'browsi',
    loadNow: true,
  })
}
export default function initBrowsi() {
  if (isBrowsiEnabled()) {
    loadBrowsiScript()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initBrowsi.js